// File: EasyStumpOut_TermsOfService_v01.tsx
// Description: Terms of Service page for {locationName}    using ReactSetv02026BSSC structure.
// Version: v01
// Created: 2026-04-14

import React from 'react';
import { Container } from 'react-bootstrap';

import EasyStumpOut_Header from "./EasyStumpOut_Header_v01_active";
import EasyStumpOut_Footer from "./EasyStumpOut_Footer_v01_active";
import { EASY_STUMP_OUT_LOCATION_DATA, ILocationConfig, Locations } from "../App_CONFIG_v01a";
import { InlinePageStyles } from '../App_STYLES_v01a';

const locationConfig = EASY_STUMP_OUT_LOCATION_DATA[Locations.coloradoFrontRange];
const locationName = locationConfig.websiteName;

type locationConfigProps = {
  locationConfig: ILocationConfig;
};




// const EasyStumpOut_TermsOfService_v01: React.FC = ({locationConfig}: locationConfigProps) => {

const EasyStumpOut_TermsOfService_v01: React.FC<locationConfigProps> = ({locationConfig}) => {
  return (
    
  <>
    <InlinePageStyles />
    <EasyStumpOut_Header locationConfig={locationConfig} />
      
    <main className="py-5">

      <Container style={{ maxWidth: '980px' }}>
        <section className="mb-4">
          <h1 className="fw-bold mb-3">Terms of Service</h1>
          <p className="text-muted mb-2">
            Effective Date: April 14, 2026
          </p>
          <p>
            Welcome to {locationName}. These Terms of Service govern your use of our website,
            communications, and stump removal related services. By accessing this website,
            requesting a quote, scheduling service, or otherwise engaging with {locationName}   ,
            you agree to these Terms of Service.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">1. Company Services</h2>
          <p>
            {locationName}   provides stump removal and related outdoor service offerings, which may
            include stump grinding, debris cleanup, root flare reduction, site review, haul-off,
            and other services as described in a quote, estimate, invoice, service agreement, or
            project proposal.
          </p>
          <p>
            Service availability may vary by location, property conditions, equipment access,
            weather, safety considerations, and scheduling capacity.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">2. Quotes, Estimates, and Scope of Work</h2>
          <p>
            Any quote or estimate provided by {locationName}   is based on the information available
            at the time, including details provided by the customer and any visible site conditions.
            Final pricing may be adjusted if actual site conditions differ materially from what was
            disclosed or observed before work begins.
          </p>
          <p>
            Examples of conditions that may affect pricing or scope include, but are not limited to,
            hidden roots, rock, concrete, fencing, underground utilities, restricted access,
            excessive slope, unexpected debris, multiple stump clusters, or changes requested by the
            customer.
          </p>
          <p>
            Work will be limited to the scope described in the approved quote, estimate, or work
            order unless both parties agree to additional work.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">3. Customer Responsibilities</h2>
          <p>
            The customer agrees to provide accurate information about the property, the location of
            the stump or stumps, site access conditions, and any known hazards. The customer is also
            responsible for the following before service begins:
          </p>
          <ul>
            <li>Providing safe and reasonable access to the work area.</li>
            <li>Ensuring pets, children, and other persons remain clear of the work zone.</li>
            <li>Disclosing known underground or concealed hazards.</li>
            <li>
              Marking or identifying private items or installations near the service area, including
              irrigation, landscape lighting, invisible fencing, septic components, or decorative
              features.
            </li>
            <li>
              Obtaining any permissions required from landlords, homeowners associations, property
              managers, or other third parties.
            </li>
          </ul>
          <p>
            Utility locating may be required before certain work can begin. The customer agrees that
            {locationName}    may delay or reschedule service if utility marking, site readiness, or
            safety conditions are incomplete.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">4. Scheduling and Access</h2>
          <p>
            Requested service dates and times are estimates only unless expressly confirmed. We may
            reschedule due to weather, equipment issues, crew availability, safety concerns, or site
            conditions outside our control.
          </p>
          <p>
            If we arrive for a scheduled appointment and cannot safely or reasonably perform the work
            due to blocked access, unrestrained animals, undisclosed conditions, or customer absence
            when required, we may charge a trip fee, rescheduling fee, or both where permitted by
            law and disclosed in advance.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">5. Payments</h2>
          <p>
            Payment terms will be stated in the applicable estimate, invoice, or service agreement.
            Unless otherwise stated in writing, payment is due upon completion of the work.
          </p>
          <p>
            {locationName}    may require deposits for larger jobs, specialty equipment, extended
            travel, or reserved project dates. Deposits may be non-refundable once scheduling,
            mobilization, or pre-job preparation has occurred, except where required otherwise by
            law.
          </p>
          <p>
            Late payments may be subject to reasonable late fees, collection costs, and any other
            remedies allowed by law.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">6. Cancellations and Refunds</h2>
          <p>
            Customers should provide as much notice as possible for cancellations or rescheduling.
            Cancellations made after equipment, labor, or travel has been committed may be subject to
            a cancellation fee where allowed by law and disclosed in advance.
          </p>
          <p>
            Refund requests will be reviewed based on the approved scope of work, services actually
            performed, and documented site conditions. No refund will be due for work completed in
            accordance with the approved service scope.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">7. Property Conditions and Surface Impact</h2>
          <p>
            Stump removal and stump grinding involve heavy equipment, cutting tools, vibration, and
            disturbance of soil and surrounding material. Even when performed carefully, these
            services may affect nearby grass, landscaping, soil grade, mulch, decorative rock,
            irrigation, and other surface or subsurface conditions.
          </p>
          <p>
            By requesting service, the customer understands and accepts that some level of normal and
            reasonable impact may occur as part of stump removal operations, especially where access
            is limited or the stump is located near obstacles, roots, edging, fencing, or hardscape.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">8. Underground Utilities and Hidden Conditions</h2>
          <p>
            {locationName}    is not responsible for damage caused by unknown, unmarked, inaccurately
            marked, or undisclosed underground lines, pipes, systems, or structures. This includes,
            but is not limited to, private irrigation lines, invisible dog fences, low-voltage
            wiring, drainage systems, septic components, private gas lines, and other concealed
            features.
          </p>
          <p>
            If hidden conditions are encountered, work may be stopped, modified, or rescheduled until
            the condition is evaluated. Additional charges may apply if the condition changes the
            scope, time, or equipment needs of the project.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">9. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, {locationName}    shall not be liable for any
            indirect, incidental, consequential, special, exemplary, or punitive damages, including
            lost profits, loss of use, project delays, landscape replacement costs beyond the scope
            of direct proven damage, or third-party claims arising from use of the website or
            services.
          </p>
          <p>
            To the maximum extent permitted by law, our total liability for any claim arising out of
            or related to the services or the website shall not exceed the amount actually paid by the
            customer for the specific service giving rise to the claim.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">10. No Guarantee of Specific Results</h2>
          <p>
            We do not guarantee that every stump can be removed to any exact depth, finish level, or
            condition unless specifically stated in writing. The final result may vary based on stump
            species, age, size, root spread, soil conditions, access limitations, buried material,
            and surrounding structures.
          </p>
          <p>
            Any recommendations regarding backfill, regrading, reseeding, sod, or future landscaping
            are general in nature unless separately contracted as part of the scope of work.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">11. Website Use</h2>
          <p>
            You agree to use {locationName}    only for lawful purposes. You may not use the website
            in any manner that could damage, disable, overburden, or interfere with the website or
            any related systems, or attempt unauthorized access to any portion of the site.
          </p>
          <p>
            Website content, including text, branding, graphics, layout, and other materials, may be
            protected by applicable intellectual property laws and may not be copied or reused without
            permission, except as otherwise allowed by law.
          </p>
        </section>

        {/* 
        ORIGINAL 
        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">12. Communications</h2>
          <p>
            By contacting {locationName}   , submitting a form, requesting a quote, or scheduling
            service, you consent to receive communications related to your request or project,
            including by phone, email, and text message where applicable and permitted by law.
          </p>
          <p>
            Standard message and data rates may apply to text messaging. Consent to receive text
            messages is not a condition of purchase unless expressly stated otherwise.
          </p>
        </section> 
        
        */}

          {/* A2P UPDATED ON 4/15/2026 */}
        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">12. Communications</h2>
          <p>
            By contacting {locationName}, submitting a form, requesting a quote, or scheduling
            service, you consent to receive communications related to your request or project,
            including by phone, email, and text message where applicable and permitted by law.
          </p>
          <p>
            If you provide a mobile phone number and opt in to receive text messages, you agree
            to receive SMS communications from {locationName} related to your inquiry, service
            requests, scheduling, updates, and customer support.
          </p>
          <p>
            Message frequency may vary. Standard message and data rates may apply depending on
            your mobile carrier and plan.
          </p>
          <p>
            You may opt out of SMS communications at any time by replying STOP to any message.
            For assistance, reply HELP or contact us through the website.
          </p>
          <p>
            Consent to receive SMS messages is not a condition of purchase.
          </p>
          <p>
            We may maintain records of SMS consent and communication preferences as part of our
            compliance and customer service practices.
          </p>
        </section>





        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">13. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless {locationName}    and its owners,
            employees, contractors, representatives, and affiliates from and against claims,
            liabilities, damages, losses, and expenses arising out of your misuse of the website,
            your breach of these Terms, your inaccurate property or project information, or your
            violation of any law or third-party right.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">14. Governing Law</h2>
          <p>
            These Terms of Service shall be governed by and interpreted in accordance with the laws of
            the state in which the service is provided or the company primarily operates, without
            regard to conflict of law principles, unless another governing law is required by
            applicable law.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">15. Changes to These Terms</h2>
          <p>
            {locationName}    may update these Terms of Service from time to time. Updated terms will
            be posted on this page with a revised effective date. Continued use of the website or
            services after changes become effective constitutes acceptance of the updated terms.
          </p>
        </section>

        <section className="mb-2">
          <h2 className="h4 fw-semibold mb-3">16. Contact Information</h2>
          <p>
            If you have questions about these Terms of Service, please contact {locationName}   
            through the contact information provided on the website.
          </p>
        </section>
      </Container>
    </main>


    <EasyStumpOut_Footer locationConfig={locationConfig} />
      
    </>

  );
};

export default EasyStumpOut_TermsOfService_v01;

// End of File: EasyStumpOut_TermsOfService_v01.tsx
// Description: Terms of Service page for EasyStumpOut.com using ReactSetv02026BSSC structure.
// Version: v01
// Last Updated: 2026-04-14
